import React from 'react';

type Props = {
  title: string;
  value: string;
};

export const ListItem: React.FC<Props> = (props) => (
  <li className='key-value key-value--list key-value--bordered-list'>
    <span className='key-value__key fw-bold'>{props.title}</span>
    <span className='key-value__value'>{props.value}</span>
  </li>
);
